export const APIEndpoints = {
    REGISTRY: {
        name: "Registry",
        endpoint: process.env.REACT_APP_REGISTRY_ENDPOINT,
    },
    USER: {
        name: "User",
        endpoint: process.env.REACT_APP_USER_ENDPOINT,
    },
    SIGNER: {
        name: "signer",
        endpoint: process.env.REACT_APP_SIGNER_ENDPOINT,
    },
    UTILITY: {
        name: "utility",
        endpoint: process.env.REACT_APP_UTILITY_ENDPOINT,
    },
};

export const APIPaths = {
    USER_PREFERENCES: "/user/preference",
    ORG_SETUP: "/org",
    UPDATE_ORG: (uuid) => `/org/${uuid}/update`,
    CREATE_ORG_INDIVIDUAL: "/org/create",
    CREATE_ORG_ORG: "/org/create",
    PUBLISH_ORG: (orgUuid, storageProvider) => `/org/${orgUuid}/publish/${storageProvider}`,
    GET_MEMBERS: (orgUuid) => `/org/${orgUuid}/member`,
    GET_MEMBER_STATUS: (orgUuid, username) => `/org/${orgUuid}/member/${username}`,
    INVITE_MEMBERS: (orgUuid) => `/org/${orgUuid}/member/invite`,
    PUBLISH_MEMBERS: (orgUuid) => `/org/${orgUuid}/member/publish`,
    SAVE_TRANSACTION: (orgUuid) => `/org/${orgUuid}/transaction`,
    ACCEPT_INVITATION: "/org/member/register",
    VERIFY_INIVITATION: "/org/member/verify",
    AI_SERVICE_LIST: (orgUuid) => `/org/${orgUuid}/services`,
    AI_CREATE_SERVICE: (orgUuid) => `/org/${orgUuid}/service`,
    SAVE_AI_SERVICE: (orgUuid, serviceUuid) => `/org/${orgUuid}/service/${serviceUuid}/save`,
    SUBMIT_AI_SERVICE: (orgUuid, serviceUuid) => `/org/${orgUuid}/service/${serviceUuid}/submit`,
    FETCH_AI_SERVICE: (orgUuid, serviceUuid) => `/org/${orgUuid}/service/${serviceUuid}`,
    AI_SERVICE_ID_VALIDATE: (orgUuid, serviceId) =>
        `/org/${orgUuid}/verify?service_id=${serviceId}`,
    ORGANIZATION_ID_VALIDATE: (orgUuid) => `/org/verify?org_id=${orgUuid}`,
    SAVE_SERVICE_TRANSACTION: (orgUuid, serviceUuid) =>
        `/org/${orgUuid}/service/${serviceUuid}/transaction`,
    FREE_CALL_SIGNER_ADDRESS: "/freecall/signer_address",
    UPLOAD_FILE: "/upload",
    SAMPLE_DAEMON_CONFIG: (orgUuid, serviceuuid) =>
        `/org/${orgUuid}/service/${serviceuuid}/group/groupId/daemon/config`,
    SEND_SLACK_FEEDBACK: "/feedback/slack",
    LAUNCH_AI_SERVICE: (org_uuid, service_uuid, storageProvider) =>
        `/org/${org_uuid}/service/${service_uuid}/publish/${storageProvider}`,
};
